import { MedicalItemsTab } from "@/Common/Models/Patient/PatientEnums";
import { MedicalItemRiskFactor } from "@/Patient/Models/MedicalSummary/MedicalItemRiskFactor";

interface ISocialHabitsSectionProps {
    socialHabits: MedicalItemRiskFactor[];
    onSocialHabitClick: (model: MedicalItemRiskFactor, view: MedicalItemsTab) => void;
}

function SocialHabitsSection(props: ISocialHabitsSectionProps): JSX.Element {
    return (
        <>
            {props.socialHabits?.map(
                (socialHabit, idx) => (
                    <a
                        key={socialHabit.EMRTemplateId + socialHabit.MedicalItemId}
                        data-cy="social-habit"
                        onClick={() => props.onSocialHabitClick(socialHabit, MedicalItemsTab.RiskFactors)}
                    >
                        {(idx ? ", " : "") + socialHabit.Name}
                    </a>
                )
            )}
        </>
    );
}

export { SocialHabitsSection };
